// extracted by mini-css-extract-plugin
export default {"wrapperSegment":"WrapperSegment_wrapperSegment__f9Qxh"};